import { IVideojsPlayer } from '../@types/video.js'

export class Controls {
  private player: IVideojsPlayer

  constructor(player: IVideojsPlayer) {
    this.player = player
  }

  public play(): void {
    if (this.adPaused) {
      this.player.ima.resumeAd()
    } else if (this.videoPaused) {
      this.player.play()?.catch(() => null)
    }
  }

  public pause(): void {
    if (this.adPlaying) {
      this.player.ima.pauseAd()
    } else if (this.videoPlaying) {
      this.player.pause()
    }
  }

  public mute(): void {
    const player = this.player

    if (player.ads.inAdBreak() && !player.ima.controller.sdkImpl.adMuted) {
      player.ima.controller.onAdMuteClick()
    } else if (!player.ads.inAdBreak() && !player.muted()) {
      player.muted(true)
    }
  }

  public unmute(): void {
    const player = this.player

    if (player.ads.inAdBreak() && player.ima.controller.sdkImpl.adMuted) {
      player.ima.controller.onAdMuteClick()
    } else if (!player.ads.inAdBreak() && player.muted()) {
      player.muted(false)
    }
  }

  public get playing(): boolean {
    return this.adPlaying || this.videoPlaying
  }

  public get paused(): boolean {
    return this.adPaused || this.videoPaused
  }

  public get adPlaying(): boolean {
    const player = this.player
    return player.ads.inAdBreak() && player.ima.controller.sdkImpl.adPlaying
  }

  public get adPaused(): boolean {
    const player = this.player
    return player.ads.inAdBreak() && !player.ima.controller.sdkImpl.adPlaying
  }

  public get videoPlaying(): boolean {
    const player = this.player
    return !player.ads.inAdBreak() && !player.paused() && player.hasStarted()
  }

  public get videoPaused(): boolean {
    const player = this.player
    return !player.ads.inAdBreak() && player.paused()
  }
}
